"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const ui_1 = require("@pixi/ui");
const WindowManager_1 = require("../managers/WindowManager");
const WigglyText_1 = require("./WigglyText");
const Global_1 = require("../Global");
class TextField extends ui_1.Input {
    constructor(app, options) {
        super(options);
        this.moveWhenEditing = false;
        this.wiggles = false;
        this.buglastlength = 0;
        if (options.wiggles) {
            // Remove our auto placeholder with our wiggle one
            this.wiggles = true;
            const p = this.placeholder;
            this.removeChild(p);
            this.placeholder = new WigglyText_1.WigglyText(app, this.placeholder.text, (this.placeholder).style, (this.placeholder).canvas);
            this.placeholder.position = p.position;
            this.placeholder.anchor = p.anchor;
            this.addChild(this.placeholder);
        }
    }
    onKeyUp(e) {
        var _a;
        let key = e.key;
        if (key === 'Unidentified') {
            // Strange bug on Android Chrome devices...
            // https://stackoverflow.com/questions/36753548/keycode-on-android-is-always-229
            const input = (e.target);
            if (((_a = input.value) === null || _a === void 0 ? void 0 : _a.length) < this.buglastlength) {
                key = 'Backspace';
            }
            else {
                key = input.value.charAt(input.selectionStart - 1);
            }
            this.buglastlength = input.value.length;
        }
        if (key === 'Backspace') {
            this._delete();
        }
        else if (key === 'Escape' || key === 'Enter') {
            this.stopEditing();
        }
        else if (key.length === 1)
            this._add(key);
    }
    createInputField() {
        super.createInputField();
        this.input.setAttribute('autocomplete', 'off');
        this.input.setAttribute('autocapitalize', 'off');
        if (this.options.maxLength) {
            this.input.setAttribute('maxlength', this.options.maxLength.toString());
        }
        this.input.style.left = (this.getGlobalPosition().x / (0, Global_1.px)()) + 'px';
        this.input.style.top = (this.getGlobalPosition().y / (0, Global_1.px)()) + 'px';
        this.input.style.width = (this._bg.width / (0, Global_1.px)()) + 'px';
        this.input.style.height = (this._bg.height / (0, Global_1.px)()) + 'px';
        this.input.style.caretColor = 'transparent';
    }
    _startEditing() {
        super._startEditing();
        WindowManager_1.WindowManager.focusField = this;
    }
    stopEditing() {
        super.stopEditing();
        WindowManager_1.WindowManager.focusField = null;
    }
    layout(fontsize = ((this.placeholder).style.fontSize)) {
        var _a, _b;
        (this.placeholder).style.fontSize = (0, Global_1.fontSize)(fontsize);
        (this.inputField).style.fontSize = (0, Global_1.fontSize)(fontsize);
        (_a = this.placeholder) === null || _a === void 0 ? void 0 : _a.position.set(this._bg.width / 2, this._bg.height / 2);
        (_b = this.inputField) === null || _b === void 0 ? void 0 : _b.position.set(this._bg.width / 2, this._bg.height / 2);
    }
    setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        return super.setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY);
    }
    destroy(options) {
        super.destroy(options);
        // Shitting UI Code does not clean up their Inputs
        const input = document === null || document === void 0 ? void 0 : document.body.querySelector('input');
        if (input) {
            input.remove();
        }
    }
}
exports.TextField = TextField;
